import { get } from './requests'

export const getHolidays = key => get(['holidays', 'get-holidays'], { key })
